import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CTA_LABEL, OFFER_ANCHOR } from '../utils/checkout';
export function StickyCTABar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('hero');
    if (!hero) return;
    const observer = new IntersectionObserver(([entry]) => setVisible(!entry.isIntersecting), {
      rootMargin: '-40px 0px 0px 0px'
    });
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-187" data-mp="1m15vw9ixe9au">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-line bg-white px-4 py-3 shadow-lift md:hidden" data-id="element-188" data-mp="1h0rzxpulmpt6">
          <div className="flex items-center justify-between gap-4" data-id="element-189" data-mp="m9zv75z01sq">
            <div className="shrink-0 leading-none" data-id="element-190" data-mp="hw5m7r44f371">
              <span className="font-heading text-2xl font-bold text-terracotta" data-id="element-191" data-mp="hukoxtqf965h">19 €</span>
              <span className="mt-1 block font-note text-[10px] text-muted" data-id="element-192" data-mp="lxhc7xqwpqfr">Pagamento unico</span>
            </div>
            <a href={OFFER_ANCHOR} className="flex flex-1 items-center justify-center rounded-xl bg-terracotta px-4 py-3.5 text-center font-heading text-[11px] font-semibold tracking-[0.06em] text-white transition-colors duration-200 ease-out hover:bg-terracotta-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terracotta focus-visible:ring-offset-2" data-id="element-193" data-mp="80lt1cgxyilz">
              {CTA_LABEL}
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}